import { createContext } from "react";

export interface FeatureFlag {
    enabled?: boolean;
}

export interface FeatureFlags {
    delAutomate?: FeatureFlag;
}

export const defaultFeatureFlags: FeatureFlags = {
    delAutomate: undefined
};

export const FeatureFlagsContext = createContext<{ isLoading: boolean; featureFlags: FeatureFlags }>({
    isLoading: false,
    featureFlags: defaultFeatureFlags
});
